import SelectProjectDialog from '../../core/project/SelectProjectDialog';
import ProjectLink from '../../vocabulary/core/ProjectLink';
import SecondaryButton from '../../core/SecondaryButton';
import ComponentLink from '../../application-core/ComponentLink';
import { withStyles } from '@material-ui/core/styles';
import Tooltip from '@material-ui/core/Tooltip';
import Typography from '@material-ui/core/Typography';
import PropTypes from 'prop-types';
import React from 'react';
import Deprecated from '../../core/Deprecated';
import { ProjectConsumer } from '../../core/providers/ProjectProvider';
import SearchSelect from '../../core/SearchSelect';
import { globalStyles as styles } from '../../core/style/gstheme';
import { checkValidForDatatype, getGraphFromProject, makeCancelable } from '../../core/utils/utils';
import GS from '../../grafsync/grafsync';
import XL from '../core/XL';

class FindOntologyRelatedResource extends React.Component {

    constructor(props) {
        super(props);
        const mode = props.targetProjectType ?
            this.getModeData(props.targetProjectType)
            :
            this.getModeData(props.projectType);
        this.state = {
            offerExternal: false,
            project: props.project,
            searchKey: "",
            text: "",
            selectedProjectType: props.projectType,
            selectProject: false,
            mode
        };
    }

    getModeData(projectType) {
        const mode = projectType === "DataProject" ?
            {
                searchType: "https://grafsync.graphifi.com/schema/gs/Resource",
                searchIn: "https://grafsync.graphifi.com/schema/gs/inDataset",
                searchLabel: "http://www.w3.org/2000/01/rdf-schema#label",
            }
            :
            {
                searchType: "http://www.w3.org/2004/02/skos/core#Concept",
                searchIn: "http://www.w3.org/2004/02/skos/core#inScheme",
                searchLabel: "http://www.w3.org/2004/02/skos/core#prefLabel",
            };
        return mode;
    }

    loadData(id) {
        this.cancellable = makeCancelable(GS.loadData([id], {}, this.props.graph, true));
        return this.cancellable;
    }

    computeSearch = (value, lang) => {

        const { searchClasses } = this.props;
        const { mode, project } = this.state;

        const isComponentSearch = searchClasses.includes("http://www.w3.org/2004/02/skos/core#ConceptScheme")
            || searchClasses.includes("http://www.w3.org/2004/02/skos/core#Collection")
            || searchClasses.includes("http://www.w3.org/2004/02/skos/core#OrderedCollection")
            || searchClasses.includes("https://grafsync.graphifi.com/schema/gs/Dataset");

        const labelProp = mode.searchLabel;
        const searchType = mode.searchType;
        const searchInProp = mode.searchIn;

        let fullSearch =
        {
            search: isComponentSearch ?
                [
                    {
                        predicate: "http://purl.org/dc/terms/title",
                        ...(value !== "") && {
                            value: value,
                            isExactMatch: false
                        }
                    }
                ]
                :
                [
                    {
                        predicate: "http://www.w3.org/1999/02/22-rdf-syntax-ns#type",
                        value: searchType
                    },
                    {
                        predicate: labelProp,
                        ...(value !== "") && {
                            value: value,
                            isExactMatch: false
                        }
                    }
                ],
            graph: [getGraphFromProject(project)],
            pageSize: 20,
            allowMissingResults: true,
            exclude: this.props.exclude,
            entailment: this.state.selectedProjectType === "TaxonomyProject" ?
                ["propertyChain"]
                :
                [],
            language: lang,
            predicates: [
                labelProp,
                searchInProp,
                "http://purl.org/dc/terms/title",
                "http://www.w3.org/2002/07/owl#deprecated",
                "https://grafsync.graphifi.com/schema/gs/iri"]
        };
        if (this.props.searchClasses.length > 0) fullSearch.search.push({
            predicate: "http://www.w3.org/1999/02/22-rdf-syntax-ns#type",
            value: this.props.searchClasses,
            inferenceGraph: this.props.customPropertyGraph
        });
        return fullSearch;
    };

    includeResource = (id) => {
        this.props.onIncludeResource(id);
        this.setState({
            text: "",
            ...(this.props.resetOnSelect) && { searchKey: this.state.text }
        });
    };

    addExternal = () => this.includeConcept(this.state.externalIRI);

    declineExternal = () => this.setState({ text: "", offerExternal: false });

    offerExternal = (iri, valid = true) => {
        if (!valid || iri.includes("graphifi")) {
            this.setState({
                offerExternal: false
            });
        }
        else if (this.props.exclude.includes(iri)) {
            this.setState({
                offerExternal: false
            });
        }
        else {
            const isValid = checkValidForDatatype(iri, "http://www.w3.org/2001/XMLSchema#anyURI");
            this.setState({
                offerExternal: isValid,
                externalIRI: iri
            });
        }
    };

    updateSearchText = (text) => this.setState({ text, offerExternal: false });

    changeProject = () => this.setState({ selectProject: true });

    exitProject = () => this.setState({ selectProject: false });

    setProject = (project, lang, selectedProjectType) => {
        const mode = this.getModeData(selectedProjectType);
        this.setState({
            project,
            selectProject: false,
            selectedProjectType,
            mode
        });
        if (this.props.onChangeProject) this.props.onChangeProject(project, selectedProjectType);
    };

    render() {
        const { allowEmpty, allowIRI, singleValue, selectedStyle, height, searchClasses, enableProjectSelection } = this.props;
        const { text, searchKey, mode, project, selectProject } = this.state;

        const isComponentSearch = searchClasses.includes("http://www.w3.org/2004/02/skos/core#ConceptScheme")
            || searchClasses.includes("http://www.w3.org/2004/02/skos/core#Collection")
            || searchClasses.includes("http://www.w3.org/2004/02/skos/core#OrderedCollection")
            || searchClasses.includes("https://grafsync.graphifi.com/schema/gs/Dataset");

        const labelAlias = GS.getAlias(mode.searchLabel);
        const inAlias = GS.getAlias(mode.searchIn);
        const labelProp = isComponentSearch ?
            "title"
            :
            labelAlias;

        if (selectProject) {
            return <SelectProjectDialog
                open={true}
                onAddProject={this.setProject}
                onExitProject={this.exitProject}
                projectTypes={[
                    "https://grafsync.graphifi.com/schema/gs/TaxonomyProject",
                    "https://grafsync.graphifi.com/schema/gs/DataProject"
                ]}
                label="Choose Project"
                includeIcon={false} />;
        }

        return (
            <ProjectConsumer>
                {({ defaultLang }) => (
                    <div>
                        {enableProjectSelection &&
                            <div style={{ width: 'calc(100% - 12px)', border: 'solid 1px #c0c0c0', borderRadius: 4, padding: 6 }}>
                                <div style={{ display: 'flex', width: '100%' }}>
                                    <div style={{ flex: 1, paddingTop: 12, overflow: 'hidden', marginRight: 12 }}>
                                        <ProjectLink
                                            id={project}
                                            defaultLang={defaultLang}
                                            graph={getGraphFromProject(project)}
                                            key={project} />
                                    </div>
                                    <div style={{ flex: 0, width: 100 }}>
                                        <SecondaryButton dataTest="change-project" onClick={this.changeProject}>Change</SecondaryButton>
                                    </div>
                                </div>
                            </div>
                        }
                        <div style={{ height }}>
                            <SearchSelect
                                key={searchKey}
                                dataTest="find-relationship"
                                focus={true}
                                allowIRIonNoResults={allowIRI}
                                sortByLength={true}
                                singleValue={singleValue}
                                selectedStyle={selectedStyle}
                                updateSearchText={this.updateSearchText}
                                allowEmpty={allowEmpty}
                                maxLength={250}
                                initialText={text}
                                search={(value, lang) => this.computeSearch(value, lang)}
                                listSecondIcon={(result) => {
                                    if (result.deprecated) return <Deprecated />;
                                    if (result.isEntailed) return <XL />;
                                    return null;
                                }}
                                listSelectionDisplay={(result, lang) => result[labelProp] ?
                                    result[labelProp][lang] ?
                                        Array.isArray(result[labelProp][lang]) ?
                                            result[labelProp][lang][0]
                                            :
                                            result[labelProp][lang]
                                        :
                                        result.id
                                    :
                                    result.id
                                }
                                listDisplay={(result, lang) => {
                                    const text = result[labelProp] ?
                                        result[labelProp][lang] ?
                                            Array.isArray(result[labelProp][lang]) ?
                                                result[labelProp][lang].sort().join(" AND ")
                                                :
                                                result[labelProp][lang]
                                            :
                                            result.id
                                        :
                                        result.id;
                                    const currentIRI = result.iri && result.iri.length > 0 ?
                                        result.iri[result.iri.length - 1]
                                        :
                                        result.id;
                                    return <div>
                                        <Typography variant="body2">
                                            <span style={{ wordBreak: 'break-word' }}>
                                                <Tooltip
                                                    PopperProps={{
                                                        "data-test": "result-tip"
                                                    }}
                                                    title={currentIRI}>
                                                    <span data-test="result-text-words">{text}</span>
                                                </Tooltip>
                                            </span>
                                        </Typography>
                                        {result[inAlias] && result[inAlias].map(dataset =>
                                            <ComponentLink
                                                handleNotAvailable={true}
                                                key={dataset}
                                                id={dataset}
                                                graph={result.inNamedGraph}
                                                defaultLang={defaultLang} />
                                        )}
                                    </div>;
                                }}
                                sortProp={labelProp}
                                isClickableResult={(result) => !result.invalid && !result.deprecated}
                                title="Find a resource"
                                onClearResults={this.declineExternal}
                                onNoResults={allowIRI ? this.offerExternal : null}
                                lang={defaultLang}
                                chosen={this.includeResource} />
                        </div>
                    </div>
                )}
            </ProjectConsumer>
        );
    }
}

FindOntologyRelatedResource.defaultProps = {
    searchClasses: [],
    projects: [],
    exclude: [],
    allowEmpty: false,
    singleValue: false,
    height: 200,
    resetOnSelect: true,
    enableProjectSelection: true,
    allowIRI: true
};

FindOntologyRelatedResource.propTypes = {
    searchClasses: PropTypes.array,
    exclude: PropTypes.array,
    targetProjectType: PropTypes.string,
    enableProjectSelection: PropTypes.bool,
    height: PropTypes.number.isRequired,
    project: PropTypes.string.isRequired,
    graph: PropTypes.string.isRequired,
    resetOnSelect: PropTypes.bool,
    customPropertyGraph: PropTypes.string,
    allowIRI: PropTypes.bool,
    allowEmpty: PropTypes.bool,
    singleValue: PropTypes.bool,
    selectedStyle: PropTypes.object,
    onChangeProject: PropTypes.func,
    onIncludeResource: PropTypes.func.isRequired,
    classes: PropTypes.object
};

export default withStyles(styles)(FindOntologyRelatedResource);